<template>
<div class="chapter">
<div class="inner_page">
<p class="c"><strong class="calibre1"><span class="calibre2" id="title"></span>Youngblood<br class="calibre3"/> Hawke</strong></p>
<p class="c1"><strong class="calibre1">Herman Wouk</strong></p>
<p class="c191a"><img alt="" class="calibre4" src="images/00001.jpeg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0000.vue?8a59e724